/*
 *  Copyright (c) 2021. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { useMemo } from "react";
import Container from "../../../../components/Container/Container";
import Layout from "../../../Layouts/Layout";
import PartnerLogoSection from "../../../../components/Sections/Generic/PartnerLogoSection/PartnerLogoSection";
import LandingPageTeaser from "../../../../components/Teaser/LandingPageTeaser";
import AttorneySection from "../../../../components/Sections/Divorce/DivorceAttorneySection/AttorneySection";
import HowItWorksSection from "../../../../components/Sections/FamilyLaw/Consulting/HowItWorksSection";
import FamilyLawConsultingCheckin from "../../../../components/Checkin/FamilyLawCheckin/Consulting/FamilyLawConsultingCheckin";
import { defaultProvenExpertTeaserCard } from "../../../../services/landingPageService";
import LinkedCardBox from "../../../../components/LinkedCardBox/LinkedCardBox";
import GreyBackgroundWrapper from "../../../../components/BackgroundWrapper/GreyBackgroundWrapper";
import LpFamilyLawConsultingAdvoCardMeta from "./AdvoCard/LpFamilyLawConsultingAdvoCardMeta";
import LpFamilyLawConsultingAragMeta from "./Arag/LpFamilyLawConsultingAragMeta";
import LpFamilyLawConsultingRolandMeta from "./Roland/LpFamilyLawConsultingRolandMeta";
import iconAttorneys from "../../../../assets/icons/generic/IconLawyers";
import iconDocument from "../../../../assets/icons/generic/IconDocument";
import { useCustomer } from "../../../../provider/Customer/CustomerProvider";
import { AbstractCase } from "../../../../types/Entities/AbstractCase";

const getMetaDataByPartner = ({ partner }: { partner: string }) => {
  switch (partner) {
    case "advocard":
      return <LpFamilyLawConsultingAdvoCardMeta />;
    case "arag":
      return <LpFamilyLawConsultingAragMeta />;
    case "roland":
      return <LpFamilyLawConsultingRolandMeta />;
    default:
      return null;
  }
};

const LpFamilyLawConsultingPartner = ({ partner }: { partner: NonNullable<AbstractCase["acquisitionPartner"]> }) => {
  const { isLoggedIn } = useCustomer();
  const metaData = useMemo(() => getMetaDataByPartner({ partner }), [partner]);

  return (
    <Layout minimal={!isLoggedIn} clickableLogo={isLoggedIn} backgroundType={"landingpage"}>
      {metaData}
      <LandingPageTeaser
        teaserButtonText={"Jetzt Starten"}
        headline={"Professionelle Hilfe im Familienrecht"}
        subheadline={"Kurz Anliegen schildern und Gespräch vereinbaren"}
        teaserButtonLink={isLoggedIn ? "/servicewelt" : "#top-checkin"}
      >
        <LinkedCardBox
          linkedCards={[
            defaultProvenExpertTeaserCard,
            {
              icon: iconAttorneys,
              heading: "Professionelle Beratung",
            },
            {
              icon: iconDocument,
              heading: "Unkomplizierte Abwicklung",
            },
          ]}
        />
      </LandingPageTeaser>
      <PartnerLogoSection partnerName={partner} containerStyle={"settlementContainer"} />
      <GreyBackgroundWrapper>
        {!isLoggedIn && (
          <Container>
            <FamilyLawConsultingCheckin idPrefix={"top"} partner={partner} />
          </Container>
        )}
        <HowItWorksSection />
      </GreyBackgroundWrapper>
      <AttorneySection
        textCards={false}
        subheading={"Sie möchten sich professionell und schnell unterstützen lassen? Wir helfen Ihnen - jederzeit und ortsunabhängig!"}
        heading={"Deutschlandweit tätige Partneranwälte"}
      />
      {!isLoggedIn && (
        <Container>
          <FamilyLawConsultingCheckin idPrefix={"top"} partner={partner} />
        </Container>
      )}
    </Layout>
  );
};

export default LpFamilyLawConsultingPartner;
